module.exports = __webpack_public_path__ + "static/acupun_1-9da224cd29894b23f4c0c1e12bce5ebc.png";